import { render, staticRenderFns } from "./FirmFilesTable.vue?vue&type=template&id=61e0ff65&scoped=true"
import script from "./FirmFilesTable.vue?vue&type=script&lang=js"
export * from "./FirmFilesTable.vue?vue&type=script&lang=js"
import style0 from "./FirmFilesTable.vue?vue&type=style&index=0&id=61e0ff65&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61e0ff65",
  null
  
)

export default component.exports